import { Config, ConfigMutate } from "../types";

const camelToSnakeCase = (str: string) =>
  str.replace(/[A-Z]/g, (letter, index) => {
    return index == 0 ? letter.toLowerCase() : "_" + letter.toLowerCase();
  });

export const transformConfig = (
  config?: Config<any, any>,
  options: {
    flatSettings?: boolean;
  } = {
    flatSettings: true,
  }
) => {
  if (!config) {
    return {};
  }

  let params: any = {};

  if (config.fields) {
    params.fields = config.fields.join(",");
  }

  if (config.extraFields) {
    params.extra_fields = config.extraFields.join(",");
  }

  if (config.filters) {
    Object.entries(config.filters).forEach(([key, value]) => {
      Object.entries(value!).forEach(([filterKey, filterValue]) => {
        params[`filter[${key}][${filterKey}]`] = filterValue;
      });
    });
  }

  if (config.order) {
    Object.entries(config.order).forEach(([key, value]) => {
      params[`order[${key}]`] = value;
    });
  }

  if (config.page) {
    Object.entries(config.page).forEach(([key, value]) => {
      params[`page[${key}]`] = value;
    });
  }

  // Parsowanie settingów dla GET
  if (config.settings && options.flatSettings) {
    Object.entries(config.settings).forEach(([key, value]) => {
      params[`setting[${camelToSnakeCase(key)}]`] = value;
    });
  }

  // Parsowanie settingów dla POST/PATCH
  if (config.settings && !options.flatSettings) {
    Object.entries(config.settings).forEach(([key, value]) => {
      params = {
        ...params,
        setting: {
          ...params.setting,
          [camelToSnakeCase(key)]: value,
        },
      };
    });
  }

  if (config.rawParams) {
    params = {
      ...params,
      ...config.rawParams,
    };
  }

  return params;
};

export const transformConfigToQuery = (config?: Config<any, any>) => {
  if (!config) {
    return "";
  }

  const params = transformConfig(config, { flatSettings: true });

  return new URLSearchParams(params);
};

export const transformConfigToBody = (config?: ConfigMutate<any, any>) => {
  if (!config) {
    return null;
  }

  const body = transformConfig(config, { flatSettings: false });

  if (config.data) {
    body.data = config.data;
  }

  if (config.extra_fields) {
    body.extra_fields = config.extra_fields;
  }

  return JSON.stringify(body);
};

export const userMessage = ({
  method,
  errorMsgNoun,
}: {
  method?: string;
  errorMsgNoun: string;
}) => {
  let action = "";

  if (method === "GET") {
    action = "fetching";
  } else if (method === "POST") {
    action = "adding";
  } else if (method === "PATCH") {
    action = "updating";
  } else if (method === "DELETE") {
    action = "deleting";
  } else {
    action = "unknown";
  }

  return `Error ${action} ${errorMsgNoun}`;
};
